<template>
  <unicom-linha class="arquivo-anexo" :espacamento="false">
    <unicom-coluna sm="auto" style="padding-right: 12px">
      <IconeNormal class="icone" />
    </unicom-coluna>
    <unicom-coluna
      sm="auto"
      alinhamento="center"
      style="height: 100%; padding-bottom: 2px"
    >
      <unicom-linha :espacamento="false" style="height: 100%">
        <unicom-coluna sm="12">
          <div>
            <span class="negrito" style="padding-right: 12px">
              {{ objetoArquivo.nomeArquivo }}
            </span>
            <span class="segunda-cor-fonte">
              {{ objetoArquivo.tamanhoArquivo }}
            </span>
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" alinhamento="end">
          <div>
            {{ objetoArquivo.usuario.nome }} - {{ objetoArquivo.dataEnvio }}
          </div>
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna>
    <unicom-coluna sm="auto" class="ml-auto" alinhamento="center">
      <span>
        <unicom-icone
          class="icone-acao"
          :class="{ desativado: !objetoArquivo.baixavel }"
          tooltipNome="Baixar"
          nome="download"
          @click.native="$emit('baixar-arquivo')"
          :tamanho="20"
        />
      </span>
      <span>
        <unicom-icone
          class="icone-acao tooltip-descricao"
          :class="{ desativado: !objetoArquivo.baixavel }"
          :tooltipNome="tooltipDescricao"
          nome="edit"
          @click.native="$emit('arquivo-para-descricao', objetoArquivo)"
          :tamanho="20"
        />
      </span>
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import IconeNormal from "../Icones/IconeNormal";

export default {
  components: {
    IconeNormal
  },
  props: {
    objetoArquivo: {
      type: Object,
      default: () => {
        return {
          nomeArquivo: "",
          tamanhoArquivo: 0,
          dataEnvio: "",
          mostrarIconeExcluir: true,
          mensagemStatus: "",
          baixavel: true,
          descricao: ""
        };
      }
    }
  },
  computed: {
    tooltipDescricao() {
      return this.objetoArquivo.descricao.trim()
        ? this.objetoArquivo.descricao.trim()
        : "Sem Comentário";
    }
  }
};
</script>

<style>
.tooltip-descricao {
  display: block;
}
.tooltip-descricao > div > div > div.tooltip {
  width: 8rem;
  word-wrap: break-word;
  white-space: break-spaces !important;
  text-align: center;
}
</style>

<style lang="scss" scoped>
@import "./Arquivo.scss";
</style>
